import { Link } from "react-router-dom";
import SEO from "@/components/site/SEO";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-brand-ink text-white">
      <SEO title="Page not found" path="/404" />
      <div className="container-page py-32 text-center">
        <p className="label-eyebrow text-brand-green">404</p>
        <h1 className="mt-4 font-display font-black text-5xl sm:text-6xl">Page not found.</h1>
        <p className="mt-5 text-white/70 max-w-md mx-auto">
          The page you’re looking for has moved or doesn’t exist. Let’s get you back home.
        </p>
        <Link
          to="/"
          data-testid="404-back-home"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-brand-green px-6 py-3 text-sm font-semibold text-white hover:bg-brand-greenHover transition-colors"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
